import React, { useEffect, useState } from 'react'
import Modal from '../../../../components/Modal'
import Api from '../../../../services/Api'
import {
  INFTCreateModalProps,
  INFTCreateModalButtons,
  INFTCreateModalButtonsState,
  NFTCreateModalButtonsStateStatusType
} from './INFTCreateModal'
import { useMintNFT } from '../../../../hooks/useYetiSwapNFTCollection'
import { INFTCreateModalWrapper, NFTCreateModalButton, NFTCreateModalButtons, NFTCreateModalHead } from './styled'
import NFTCreateStepStatus from './NFTCreateStepStatus'
import { useApproveCallback } from '../../../../hooks/useApproveCallback'
import { IDefaultCard, NFTFileFormats } from '../../nftFormats/Default/Card/IDefaultCard'
import { Redirect } from 'react-router-dom'
import jsonToFile from '../../../../utils/jsonToFile'

//@ts-ignore
import { Web3Storage } from 'web3.storage/dist/bundle.esm.min.js'

const ipfsStorage = new Web3Storage({ token: process.env.REACT_APP_STORAGE_KEY })

const NFTCreateButtonsInitialState: INFTCreateModalButtonsState = {
  approve: { status: 'none', disabled: false },
  uploadFiles: { status: 'none', disabled: true },
  mintNFT: { status: 'none', disabled: true }
}

export default function NFTCreateModal(props: INFTCreateModalProps) {
  const { isOpen, onDismiss, nftFile, coverFile, nftFormData, mintFee, collectionAddress, properties } = props
  const [buttonsState, setButtonsState] = useState<INFTCreateModalButtonsState>(NFTCreateButtonsInitialState)
  const { mintNFT } = useMintNFT(nftFormData.royalties)
  const mintedState = buttonsState['mintNFT'].status === 'success' && buttonsState['mintNFT'].disabled

  const mintFeeText = mintFee ? mintFee.toFixed(0, { groupSeparator: ',' }) : ''
  const fileType = nftFile ? nftFile.type.split('/')[0] : 'image'

  const [ipfsHash, setIpfsHas] = useState(null)
  // todo: mintFee currency amount olarak değiştirilmeli
  const [approveFeeState, approveCallback] = useApproveCallback(mintFee, collectionAddress)

  useEffect(() => {
    if (approveFeeState === 3) {
      setButtonsState({
        ...buttonsState,
        approve: { status: 'success', disabled: true },
        uploadFiles: { status: 'none', disabled: false }
      })
    } else if (approveFeeState === 2) {
      setButtonsState({ ...buttonsState, approve: { status: 'pending', disabled: true } })
    } else if (approveFeeState === 0) {
      setButtonsState({ ...buttonsState, approve: { status: 'none', disabled: false } })
    }
  }, [approveFeeState, setButtonsState])

  function Approve() {
    approveCallback()
  }

  const uploadFailed = () => {
    setButtonsState({ ...buttonsState, uploadFiles: { status: 'error', disabled: false } })
  }

  function UploadJSON(NFTJson: IDefaultCard) {
    ipfsStorage.put([jsonToFile(NFTJson)], { wrapWithDirectory: false })
      .then((Hash: any) => {
        if (Hash) {
          setIpfsHas(Hash)
          setButtonsState({
            ...buttonsState,
            uploadFiles: { status: 'success', disabled: true },
            mintNFT: { status: 'none', disabled: false }
          })
        }
      })
      .catch(() => {
        uploadFailed()
      })
  }

  function Upload() {
    if (nftFile) {
      setButtonsState({ ...buttonsState, uploadFiles: { status: 'pending', disabled: true } })
      ipfsStorage.put([nftFile], { wrapWithDirectory: false })
        .then((Hash: any) => {
          if (Hash) {
            let NFTJson: IDefaultCard = {
              name: nftFormData.title,
              image: Hash,
              coverImage: '',
              type: NFTFileFormats[fileType],
              description: nftFormData.description,
              attributes: properties.filter(item => item.show && item.key && item.value),
              externalUrl: nftFormData.externalUrl
            }

            if (coverFile) {
              ipfsStorage.put([coverFile], { wrapWithDirectory: false })
                .then((coverResult: any) => {
                  if (coverResult) {
                    NFTJson = {
                      ...NFTJson,
                      coverImage: coverResult
                    }

                    UploadJSON(NFTJson)
                  }
                })
                .catch(() => {
                  uploadFailed()
                })
            } else {
              UploadJSON(NFTJson)
            }
          }
        })
        .catch(() => {
          uploadFailed()
        })
    }
  }

  function MintNFT() {
    if (mintNFT && ipfsHash) {
      setButtonsState({ ...buttonsState, mintNFT: { status: 'pending', disabled: true } })
      mintNFT(ipfsHash)
        .then((res: any) => {
          setButtonsState({ ...buttonsState, mintNFT: { status: 'success', disabled: true } })
        })
        .catch(() => {
          setButtonsState({ ...buttonsState, mintNFT: { status: 'error', disabled: false } })
        })
    }
  }

  function getButtonStatusClassName(status: NFTCreateModalButtonsStateStatusType, disabled: boolean): string {
    let result = ''

    if ((status === 'none' || status === 'success') && disabled) {
      result = 'disabled'
    } else if (status === 'pending') {
      result = 'pending'
    }
    return result
  }

  const NftCreateButtonList: INFTCreateModalButtons[] = [
    {
      id: 'approve',
      title: 'Approve',
      description: 'Approve performing transactions with your wallet',
      buttonText: approveFeeState === 3 ? `Approved` : 'Approve',
      buttonFunction: () => Approve()
    },
    {
      id: 'uploadFiles',
      title: 'Upload files',
      description: 'Prepare files for minting',
      buttonText: 'Upload files',
      buttonFunction: () => Upload()
    },
    {
      id: 'mintNFT',
      title: 'Mint NFT',
      description: 'Call contract method',
      buttonText: `Mint NFT${mintFeeText !== '0' ? ' ' + mintFeeText + ' YTS' : ''}`,
      buttonFunction: () => MintNFT()
    }
    /*
    todo: mf
    {
      id: 'signSellOrder',
      title: 'Sign sell order',
      description: 'Sign sell order using your wallet',
      buttonText: 'Sign sell order',
      buttonFunction: () => {
      }
    }*/
  ]

  return (
    <Modal onDismiss={() => { }} isOpen={isOpen} maxHeight={90}>
      <INFTCreateModalWrapper>
        <NFTCreateModalHead>
          <div className="title">Follow Steps</div>
          <div className="close" onClick={onDismiss}>
            x
          </div>
        </NFTCreateModalHead>
        <NFTCreateModalButtons>
          {NftCreateButtonList.map((item: INFTCreateModalButtons) => {
            const disabled = buttonsState[item.id].disabled
            const status = buttonsState[item.id].status
            return (
              <NFTCreateModalButton key={item.id}>
                <div className="button-head">
                  <div className="button-status">
                    <NFTCreateStepStatus status={status} />
                  </div>
                  <div className="button-text">
                    <div className="button-title">{item.title}</div>
                    <div className="button-description">{item.description}</div>
                  </div>
                </div>
                <div className="button">
                  <button
                    className={getButtonStatusClassName(status, disabled)}
                    disabled={disabled}
                    onClick={() => item.buttonFunction()}
                  >
                    {item.buttonText}
                  </button>
                </div>
              </NFTCreateModalButton>
            )
          })}
        </NFTCreateModalButtons>
        {mintedState && <Redirect to={`/profile/wallet?tab=collection`} />}
      </INFTCreateModalWrapper>
    </Modal>
  )
}
